import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants/enums";
import { FAQListItem } from "../../content.types";
import { ReorderFaqItemsRequestBody } from "./reorderFaqItems.types";

export const requestReorderFaqItems = async (
  body: ReorderFaqItemsRequestBody
): Promise<{ data: FAQListItem[] }> => {
  return await instance.patch(ApiRoutesContent.FAQItemsReorder, body);
};
